/**
 * EventDeleteRow
 *
 * Delete event button with confirmation dialog.
 * Only shown in edit mode of the event modal.
 */

import { Alert, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Colors } from '@/constants/theme';
import { Spacing } from '@/constants/spacing';
import { getBodyFont } from '@/constants/typography';

type EventDeleteRowProps = {
  eventTitle: string;
  onDelete: () => void;
  palette: typeof Colors.light;
};

export function EventDeleteRow({
  eventTitle,
  onDelete,
  palette,
}: EventDeleteRowProps) {
  const handlePress = () => {
    Alert.alert(
      'Delete Event',
      `Delete '${eventTitle}'? This cannot be undone.`,
      [
        { text: 'Cancel', style: 'cancel' },
        { text: 'Delete', style: 'destructive', onPress: onDelete },
      ]
    );
  };

  return (
    <TouchableOpacity
      style={styles.container}
      onPress={handlePress}
      activeOpacity={0.7}
    >
      <View style={styles.iconContainer}>
        <Ionicons name="trash-outline" size={18} color={palette.danger} />
      </View>
      <Text style={[styles.label, { fontFamily: getBodyFont(), color: palette.danger }]}>
        Delete event
      </Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: Spacing.lg,
    paddingVertical: Spacing.md + 2, // 14px
    marginTop: Spacing.lg,
  },
  iconContainer: {
    width: 40,
    alignItems: 'center',
  },
  label: {
    fontSize: 14,
  },
});
